import React, { use, useEffect, useRef, useState } from "react";
import "../styles/style.css";
import "../styles/CategoryPage.css";
import { useNavigate } from "react-router-dom";
import { showAlert } from "../utilities/alertService";
import Loader from "../utilities/Loader";
import config from "../services/config";
import ComingSoon from "../component/ComingSoon";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";
import logOutLogo from "../assets/images/logout.png";
import mouseClick from "../assets/audio/mouseClick.mp3";
import { useLocation } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
import GotraKuldevi from "../component/GotraKuldevi";


export default function CategoryPage() {

  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [podcastList, setPodcastList] = useState([])
  const [resourceData, setResourceData] = useState([])
  const [bloggerData, setBloggerData] = useState([])
  const [artPicData, setArtPicData] = useState([])
  const location = useLocation();
  // const profileData = location.state?.profileData;
  const [profileData, setProfileData] = useState(null);
  const [showGotraKuldeviPopup, setShowGotraKuldeviPopup] = useState(false);

  console.log("Received profile data:", profileData);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setActiveDropdown(null); // close dropdown
      }
    };

    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  useEffect(() => {
    getCategoryList();
    // getPodcastList();
    getuserData()
  }, []);

  const getuserData = async () => {
    try {
      const payload = {
        user_id: localStorage.getItem("id"),
      };
      const response = await config.getUserProfile(payload);
      if (response.status === true && response.image_base64) {
        setProfileData(response.image_base64);
      }
    } catch (error) {
      console.error("Error fetching Profile Data:", error);
    }
  };

  const getCategoryList = async () => {
    try {
      setLoading(true);
      const response = await config.getActiveCategory();
      console.log("category List:", response);
      if (response.status === 200) {
        setCategoryList(response.data);
      } else {
        showAlert("error", response.message || "Failed to fetch country list");
      }
    } catch (error) {
      console.error("Error fetching country list:", error);
    }
    finally {
      setLoading(false);
    }
  };

  const getPodcastList = async () => {
    try {
      setLoading(true);
      const response = await config.getPodcasts();
      console.log("podcast List:", response);
      if (response.success === true) {
        setPodcastList(response.data);
      } else {
        showAlert("error", response.message || "Failed to fetch podcast list");
      }
    } catch (error) {
      console.error("Error fetching podcast list:", error);
    }
    finally {
      setLoading(false);
    }
  };

  const getCategoeryData = async (categoryId) => {
    try {

      setLoading(true);
      const payload = {
        company_id: 1,
        category_id: categoryId, // Example category ID
      };
      const response = await config.getResourceData(payload);
      console.log("cat data:", response);
      if (response.success === true) {
        setResourceData(response.data);
      } else {
        showAlert("error", response.message || "Failed to fetch category data");
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  const getBlogger = async (categoryId) => {
    try {

      setLoading(true);
      const payload = {
        company_id: 1,
        // category_id: categoryId, // Example category ID
      };
      const response = await config.getBlogger(payload);
      console.log("blogger:", response);
      if (response.status === true) {
        setBloggerData(response.data);
      } else {
        showAlert("error", response.message || "Failed to fetch blogger data");
      }
    } catch (error) {
      console.error("Error fetching blogger data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBloggerClick = (blogger) => {
    const blogSlug = blogger.blogger_title
      ?.toLowerCase()
      ?.replace(/[^a-z0-9]+/g, "-") // replace spaces/symbols with hyphen
      ?.replace(/(^-|-$)/g, ""); // remove leading/trailing hyphens

    // const url = `/category/${blogSlug}`;
    const url = `/category/${'Blog'}`;
    const fullUrl = `${window.location.origin}${url}?id=${blogger.id}&title=${encodeURIComponent(blogger.blogger_title)}`;
    // window.open(
    //   `${window.location.origin}${url}?id=${blogger.id}`,
    //   "_blank"
    // );
    window.open(fullUrl, "_blank");
  };
  
   const getPhotographyArt = async (categoryId) => {
    try {
      setLoading(true);
      const payload = {
        company_id: 1,
        category_id: categoryId, // Example category ID
      };
      const response = await config.getArtPhotographyImages(payload);
      console.log("artpho:", response);
      if (response.success === true) {
        setArtPicData(response.data);
      } else {
        showAlert("error", response.message || "Failed to fetch Photography/art data");
      }
    } catch (error) {
      console.error("Error fetching Photography/art data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  const handlePicArtClick = (item,cat) => {
    const blogSlug = item.title_name
      ?.toLowerCase()
      ?.replace(/[^a-z0-9]+/g, "-") // replace spaces/symbols with hyphen
      ?.replace(/(^-|-$)/g, ""); // remove leading/trailing hyphens

    // const url = `/category/${blogSlug}`;
    const url = `/category/${cat}`;
    const fullUrl = `${window.location.origin}${url}?id=${item.id}&title=${encodeURIComponent(item.title_name)}`;
    // window.open(
    //   `${window.location.origin}${url}?id=${blogger.id}`,
    //   "_blank"
    // );
    window.open(fullUrl, "_blank");
  };

  const handleDownload = async (item) => {
    setLoading(true);
    try {
      // 🔹 Step 1 — Fetch data from API
      const payload = { id: item.id };
      const response = await config.getPatrikaImagesByResourceId(payload);
      console.log("patrika:", response);

      // ✅ Step 2 — Validate response
      if (!response?.success || !response.data || response.data.length === 0) {
        showAlert("error", "No image or PDF found for this record.");
        return;
      }

      // 🔹 Step 3 — Extract base64 content
      const fileData = response.data[0];
      const base64Data = fileData.image_path;

      if (!base64Data) {
        showAlert("error", "File missing or invalid Base64 data.");
        return;
      }

      // 🔹 Step 4 — Detect file type
      const isPdf = base64Data.startsWith("data:application/pdf");
      const isImage = base64Data.startsWith("data:image/");
      let extension = "file";

      if (isPdf) extension = "pdf";
      else if (isImage) {
        const match = base64Data.match(/^data:image\/(.*?);base64,/);
        extension = match ? match[1] : "png";
      }

      // 🔹 Step 5 — Create download link dynamically
      const link = document.createElement("a");
      link.href = base64Data;
      link.download = `patrika_${item.title_name}.${extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      console.log(`✅ Download started: patrika_${item.id}.${extension}`);
    } catch (error) {
      console.error("Error fetching Patrika data:", error);
      showAlert("error", "Failed to download file.");
    } finally {
      setLoading(false);
    }
  };

  // const handleCategoryClick = async (categoreyId) => {
  //   const sound = document.getElementById("clickSound");
  //   if (sound) {
  //     sound.currentTime = 0;
  //     sound.play().catch(err => console.log("Audio play blocked:", err));
  //   }

  //   if (categoreyId === 1) {
  //     // Call API only when Podcast is clicked
  //     await getPodcastList();
  //     setActiveDropdown((prev) =>
  //       prev === categoreyId ? null : categoreyId
  //     );
  //   } 
  //   // else if (name.toLowerCase() === "numerology") {
  //   //   // Open Numerology YouTube link in new tab
  //   //   window.open("https://www.youtube.com/watch?v=ZQ8NFIjF8D8", "_blank");
  //   // } else if (name.toLowerCase() === "astrology") {
  //   //   // Open Astrology YouTube link in new tab
  //   //   window.open("https://youtu.be/osx9OabzbzU?si=GF6KPeln40AyALOb", "_blank");
  //   // } else if (name.toLowerCase() === "patrika") {
  //   //   // Open Astrology YouTube link in new tab
  //   //   window.open("https://heyzine.com/flip-book/e22eef4f8d.html", "_blank");
  //   // } 
  //   else {
  //     setShowPopup(true);
  //   }
  // };

  const handleCategoryClick = async (categoryId) => {
    const sound = document.getElementById("clickSound");
    if (sound) {
      sound.currentTime = 0;
      sound.play().catch(err => console.log("Audio play blocked:", err));
    }
    try {
      if (categoryId === 1) {
        // Podcast
        await getPodcastList();
      } else if (categoryId === 2) {
        // Blog
        await getBlogger(categoryId);
        } else if (categoryId === 6) {
        // Photography
        await getPhotographyArt(categoryId);
      } else if (categoryId === 7) {
        // Career
        await getCategoeryData(categoryId);
        } else if (categoryId === 9) {
        // Art
        await getPhotographyArt(categoryId);
      } else if (categoryId === 14) {
        // Numerology
        await getCategoeryData(categoryId); // Example: replace with your actual API function
      } else if (categoryId === 16) {
        // Astrology
        await getCategoeryData(categoryId);
      } else if (categoryId === 17) {
        // Patrika
        await getCategoeryData(categoryId);
      } else if (categoryId === 11) {
        // Vastu
        await getCategoeryData(categoryId);
      } else if (categoryId === 12) {
        // gotra kuldevi
        setShowGotraKuldeviPopup(true);
        // navigate('/gotrakuldevi');
        return; // Stop execution here to prevent dropdown toggle
      } else {
        setShowPopup(true);
        return; // Stop execution here if popup is shown
      }
      // For all valid categories (1–4), toggle the dropdown
      setActiveDropdown((prev) =>
        prev === categoryId ? null : categoryId
      );

    } catch (error) {
      console.error("Error handling category click:", error);
    }
  };

  const getInitials = (firstname, lastname) => {
    return `${firstname[0]}${lastname[0]}`.toUpperCase();
  };

  const closePopup = () => setShowGotraKuldeviPopup(false);

  return (
    <div className="categorypage">
      <div className="bordertop">
        <div className="container">
          <div className="row verticalalign firstrow">
            <div className="col-md-8">
              <h1>Categories</h1>
            </div>
            <div className="col-md-2 profileimage" >
              <img
                src={profileData}
                alt="profile"
              />
              <div
                className=""
                style={{
                  color: "white",
                  fontSize: "13px",
                  fontFamily: "'Broadsheet LDO'",
                }}
              >
                {localStorage.getItem("name") || "User Name"}
              </div>
            </div>
            <div className="col-md-2">
              <div className="logo-section textcenter">
                <div>
                  <img src={bhrigu_logo} alt="Bhrigu Logo" />
                </div>
                {/* <div className="logo">
                <img src={bhrigu} alt="Bhrigu Logo" />
              </div>
              <div className="slider">
                <img src={lineage} alt="lineage1" />
                <img src={lineage2} alt="lineage2" />
                <img src={lineage3} alt="lineage3" />
                <img src={lineage4} alt="lineage4" />
                <img src={lineage5} alt="lineage5" />
                <img src={lineage6} alt="lineage6" />
              </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Categories Grid */}
        {loading && <Loader />}
        <div className="container">
          <div className="row verticalalign">
            {categoryList.map((cat, index) => (
              <div className="col-md-2 catcont textcenter" key={index}>
                <figure>
                  <img src={cat.image_base64} alt={cat.label} className="img-fluid" />
                </figure>
                <button
                  className="cat-link sound-link"
                  onClick={() => handleCategoryClick(cat.categoryid)}
                >
                  {cat.categoryname}
                </button>
                {/* Dropdown for Podcasts */}
                {activeDropdown === 1 &&
                  cat.categoryid === 1 &&
                  podcastList.length > 0 && (
                    <div ref={dropdownRef} className="dropdown-menu">
                      <ul
                        style={{
                          display: podcastList.length > 8 ? "flex" : "block",
                          flexWrap: podcastList.length > 8 ? "wrap" : "nowrap",
                          gap: "10px",
                          maxWidth: podcastList.length > 8 ? "600px" : "auto", // adjust width as per design
                          listStyle: "none",
                          padding: 0,
                          margin: 0,
                        }}
                      >
                        {podcastList.map((podcast) => {
                          const initials = podcast.podcaster_name
                            ? podcast.podcaster_name
                              .split(" ")
                              .map((n) => n[0].toUpperCase())
                              .join("")
                            : "";

                          return (
                            <li
                              key={podcast.id}
                              onClick={() => window.open(podcast.podcast_url, "_blank")}
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "6px",
                                minWidth: "150px", // ensures consistent spacing in horizontal layout
                                // marginBottom: "5px",
                                paddingLeft: "4px",
                              }}
                            >
                              {podcast.image_base64 ? (
                                <img
                                  src={podcast.image_base64}
                                  alt={podcast.podcaster_name}
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    backgroundColor: "#ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {initials}
                                </div>
                              )}
                              <span>{podcast.podcast_name}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                {activeDropdown === 2 &&
                  cat.categoryid === 2 &&
                  bloggerData.length > 0 && (
                    <div ref={dropdownRef} className="dropdown-menu">
                      <ul
                        style={{
                          display: bloggerData.length > 8 ? "flex" : "block",
                          flexWrap: bloggerData.length > 8 ? "wrap" : "nowrap",
                          gap: "10px",
                          maxWidth: bloggerData.length > 8 ? "600px" : "auto",
                          listStyle: "none",
                          padding: 0,
                          margin: 0,
                        }}
                      >
                        {bloggerData.map((blogger) => {
                          const initials = blogger.blogger_name
                            ? blogger.blogger_name
                              .split(" ")
                              .map((n) => n[0].toUpperCase())
                              .join("")
                            : "";

                          return (
                            <li
                              key={blogger.id}
                              onClick={() => handleBloggerClick(blogger)}
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "6px",
                                minWidth: "150px",
                                paddingLeft: "4px",
                              }}
                            >
                              {blogger.image_base64 ? (
                                <img
                                  src={blogger.image_base64}
                                  alt={blogger.blogger_name}
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    backgroundColor: "#ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {initials}
                                </div>
                              )}
                              <span>{blogger.blogger_title}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

                  {activeDropdown ===  cat.categoryid &&
                  (cat.categoryid === 6 || cat.categoryid === 9 )&&
                  artPicData.length > 0 && (
                    <div ref={dropdownRef} className="dropdown-menu">
                      <ul
                        style={{
                          display: bloggerData.length > 8 ? "flex" : "block",
                          flexWrap: bloggerData.length > 8 ? "wrap" : "nowrap",
                          gap: "10px",
                          maxWidth: bloggerData.length > 8 ? "600px" : "auto",
                          listStyle: "none",
                          padding: 0,
                          margin: 0,
                        }}
                      >
                        {artPicData.map((item) => {
                          const initials = item.resource_name
                            ? item.resource_name
                              .split(" ")
                              .map((n) => n[0].toUpperCase())
                              .join("")
                            : "";

                          return (
                            <li
                              key={item.id}
                              // onClick={() => handlePicArtClick(item,cat.categoryid)}
                               onClick={() => window.open(item.url, "_blank")}
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "6px",
                                minWidth: "150px",
                                paddingLeft: "4px",
                              }}
                            >
                              {item.image_base64 ? (
                                <img
                                  src={item.image_base64}
                                  alt={item.resource_name}
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    backgroundColor: "#ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {initials}
                                </div>
                              )}
                              <span>{item.resource_name}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

                {activeDropdown !== 1 && activeDropdown !== 2 && activeDropdown !== 6 && activeDropdown !== 9 &&
                  cat.categoryid === activeDropdown &&
                  resourceData.length > 0 && (
                    <div ref={dropdownRef} className="dropdown-menu">
                      <ul
                        style={{
                          display: resourceData.length > 8 ? "flex" : "block",
                          flexWrap: resourceData.length > 8 ? "wrap" : "nowrap",
                          gap: "10px",
                          maxWidth: resourceData.length > 8 ? "600px" : "auto",
                          listStyle: "none",
                          padding: 0,
                          margin: 0,
                        }}
                      >
                        {resourceData.map((item) => {
                          const initials = item.resource_master_name
                            ? item.resource_master_name
                              .replace(/-/g, " ")
                              .split(" ")
                              .map((n) => n[0]?.toUpperCase())
                              .join("")
                            : "";

                          return (
                            <li
                              key={item.id}
                              onClick={() => window.open(item.title_url, "_blank")}
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: "6px",
                                minWidth: "150px",
                                // marginBottom: "5px",
                                paddingLeft: "4px",
                              }}
                            >
                              {item.resource_profile ? (
                                <img
                                  src={item.resource_profile}
                                  alt={item.resource_master_name}
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "50%",
                                    backgroundColor: "#ccc",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {initials}
                                </div>
                              )}
                              {/* Title + optional download icon */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  flexGrow: 1,
                                  gap: "8px",
                                }}
                              >
                                <span>{item.title_name}</span>

                                {/* ✅ Flipbook + Download icons only for category 17 */}
                                {cat.categoryid === 17 && (
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    {/* 🔹 Flipbook Button */}
                                    <span
                                      onClick={() => window.open(item.title_url, "_blank")}
                                      style={{
                                        cursor: "pointer",
                                        color: "black",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        transition: "color 0.2s ease",
                                      }}
                                      onMouseEnter={(e) => (e.target.style.color = "#0056b3")}
                                      onMouseLeave={(e) => (e.target.style.color = "black")}
                                      title="Open Flipbook"
                                    >
                                      FB
                                    </span>

                                    {/* 🔹 Download Icon */}
                                    <FiDownload
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(item);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        color: "black",
                                        fontSize: "18px",
                                        transition: "color 0.2s ease",
                                      }}
                                      onMouseEnter={(e) => (e.target.style.color = "#0056b3")}
                                      onMouseLeave={(e) => (e.target.style.color = "black")}
                                      title="Download Patrika"
                                    />
                                  </div>
                                )}
                              </div>

                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

              </div>
            ))}
          </div>
          {showPopup && <ComingSoon onClose={() => setShowPopup(false)} />}
        </div>
        <div className="container">
          <div className="text-right logoutsign"><a href="#"><img src={logOutLogo} alt="logout" onClick={() => { localStorage.clear(); navigate('/'); }} /></a></div>
        </div>
        {/* Audio element */}
        <audio id="clickSound" src={mouseClick}></audio>
        {showGotraKuldeviPopup && (
          <div className="modal-overlay" onClick={closePopup}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
            >
              <button className="close-btn" onClick={closePopup}>
                ✕
              </button>
              <GotraKuldevi />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
